/**
 * @generated SignedSource<<890901b59253fb536998a5c69a4877bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsMap_map",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapContextProvider_map"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContributionsMapNewContributionBox_map"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContributionsMapLayout_map"
        }
      ],
      "type": "ContributionsMap",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "participativeModule",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ParticipativeModuleAuthorizations",
              "kind": "LinkedField",
              "name": "authorizations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contributionsSubmissionAuthorized",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contributionsDisplayAuthorized",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Theme",
              "kind": "LinkedField",
              "name": "themes",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContributionsMapThemeBox_theme"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ParticipativeModule",
          "abstractKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContributionsMapContributionsManager_participativeModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContributionsMapContributionsMarkersManager_participativeModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapSidebar_map"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapSidebar_sidebar"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapFilters_map"
    }
  ],
  "type": "ParticipativeModuleVisualization",
  "abstractKey": "__isParticipativeModuleVisualization"
};
})();

node.hash = "f17a1e22721599aa678da4824d6f65b0";

module.exports = node;
